var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-navigation-drawer",
    {
      staticClass: "soli-grey shadow-sidenav",
      staticStyle: { "z-index": "10" },
      attrs: {
        app: "",
        permanent: "",
        width: "200",
        touchless: "",
        dark: "",
        "mini-variant": "",
      },
    },
    [
      _c(
        "Link",
        { attrs: { href: "/" } },
        [
          _c(
            "v-list-item",
            { staticClass: "mb-4 mt-1 flex justify-center" },
            [
              _c("jet-application-mark", {
                staticClass: "block h-9 w-auto",
                staticStyle: { height: "2rem !important" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-list",
        _vm._l(_vm.tabs, function (item) {
          return _c(
            "Link",
            { key: item.title, attrs: { href: item.link, link: "" } },
            [
              item.permission
                ? _c(
                    "v-list-item",
                    {
                      class: [
                        _vm.page === item.comp ||
                        _vm.page == item.link.split("#")[0]
                          ? _vm.activeClass
                          : "",
                      ],
                      attrs: { link: "" },
                    },
                    [
                      _c(
                        "v-list-item-icon",
                        { staticClass: "flex flex-col" },
                        [
                          item.badge
                            ? _c(
                                "v-badge",
                                {
                                  attrs: {
                                    content: _vm.unreadMessageCount,
                                    color: _vm.unreadMessageCount
                                      ? "soli-red"
                                      : null,
                                    overlap: "",
                                  },
                                },
                                [_c("v-icon", [_vm._v(_vm._s(item.icon))])],
                                1
                              )
                            : _c("v-icon", [_vm._v(_vm._s(item.icon))]),
                          _vm._v(" "),
                          _vm.showMacros
                            ? _c("v-list-item-subtitle", [
                                _vm._v(_vm._s(item.macro)),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item-content",
                        [
                          false
                            ? _c("v-list-item-title", [
                                _vm._v(_vm._s(item.title)),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }